export const seriesPermissions = {
  SERIES_VIEW: {
    enabled: [
      'series_oo_view',
      'series_oo_edit',
      'series_oo_create',
      'series_partner_view',
      'series_partner_edit',
      'series_partner_create',
      'series_view_oo',
      'series_edit_oo',
      'series_create_oo',
      'series_view_partner',
      'series_edit_partner',
      'series_create_partner',
    ],
  },
  SERIES_CREATE: {
    enabled: ['series_oo_create', 'series_partner_create', 'series_create_oo', 'series_create_partner'],
  },
  SERIES_EDIT: {
    enabled: ['series_oo_edit', 'series_partner_edit', 'series_edit_oo', 'series_edit_partner'],
    disabled: [
      'series_oo_view',
      'series_oo_delete',
      'series_oo_create',
      'series_partner_view',
      'series_partner_delete',
      'series_partner_create',
      'series_view_oo',
      'series_delete_oo',
      'series_create_oo',
      'series_view_partner',
      'series_delete_partner',
      'series_create_partner',
    ],
  },
  SERIES_DELETE: {
    enabled: ['series_oo_delete', 'series_partner_delete'],
  },
};
